export default __webpack_public_path__ + "images/mloul-lelekher-icon.svg";